/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class AuditableEntity {
    insertedBy: string = undefined;
    insertedOn: Date = undefined;
    updatedBy: string = undefined;
    updatedOn: Date = undefined;
}
